export const EMIT_EVENT = Symbol('EMIT_EVENT');
//# sourceMappingURL=ActorClient.contract.js.map